"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["className"];
var TicketCardSkeleton = function TicketCardSkeleton(_ref) {
  var className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledTicketCardSkeletonWrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_reactContentLoader["default"], (0, _extends2["default"])({
    speed: 2,
    width: 280,
    height: 160,
    viewBox: "0 0 280 160",
    backgroundColor: "#e6e6e6",
    foregroundColor: "#ffffff",
    uniqueKey: "ticketcard-skeleton"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "65",
    y: "37",
    rx: "3",
    ry: "3",
    width: "170",
    height: "14"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "65",
    y: "25",
    rx: "3",
    ry: "3",
    width: "110",
    height: "8"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "65",
    y: "55",
    rx: "3",
    ry: "3",
    width: "126",
    height: "8"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "30",
    cy: "45",
    r: "20"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10",
    y: "100",
    rx: "6",
    ry: "6",
    width: "135",
    height: "16"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10",
    y: "126",
    rx: "6",
    ry: "6",
    width: "90",
    height: "10"
  })));
};
var StyledTicketCardSkeletonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TicketCardSkeleton__StyledTicketCardSkeletonWrapper",
  componentId: "sc-1d5444a-0"
})(["width:280px;background:#f5f3f2;border-radius:4px;"]);
var _default = exports["default"] = TicketCardSkeleton;